import React, { Component } from 'react'
import { styled } from '@mui/material/styles';
import classNames from 'classnames'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Switch from '@mui/material/Switch'
import FormControlLabel from '@mui/material/FormControlLabel'
import Collapse from '@mui/material/Collapse'
import TranslationFields from './TranslationFields'
import { Trans, withTranslation, useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import { TextField } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import InfoIcon from '@mui/icons-material/Info'
import { bindActionCreators } from 'redux'
import { updateAutoTranslations } from '../modules/shop'
import { connect } from 'react-redux'
import withRouter from 'with-router'
import SourceToTargetMenu from './SourceToTargetMenu'
import IconButton from '@mui/material/IconButton'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined'

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    // dark mode takes the dark primary step so the white text keeps its contrast
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.accentMuted,
    color: theme.palette.primary.contrastText,
    maxWidth: 350,
    fontSize: theme.typography.pxToRem(12),
    padding: '12px 14px',
    boxShadow:
      '0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12)'
  }
}))

class SeoFields extends React.Component {
  cachedFields = []

  constructor(props) {
    super(props)

    this.state = {
      showInfo: true,
      collapsed: true,
      updateNumber: 0,
      inheritSeoFields: true,
      menuAnchor: null,
      menuFieldId: null,
      page_title: '',
      page_description: ''
    }
  }

  componentDidMount = () => {
    // Calc if SEO fields are are inheriting
    let inheritSeoFields = true
    if (
      (this.props.fields[0] && this.props.fields[0].customized) ||
      (this.props.fields[1] && this.props.fields[1].customized)
    ) {
      inheritSeoFields = false
    }

    this.setState({
      inheritSeoFields: inheritSeoFields,
      // TODO - remove page_title and page_description state since they are not used anymore?
      page_title: this.getSeoFieldValue(
        'page_title',
        this.props.fields[0] && this.props.fields[0].customized
      ),
      page_description: this.getSeoFieldValue(
        'page_description',
        this.props.fields[1] && this.props.fields[1].customized
      )
    })

    if (this.props.onLoaded) {
      setTimeout(() => {
        if (this.hasMounted) {
          this.props.onLoaded()
        }
      }, 100)
    }
  }

  handleChange = (event, data) => {
    let targetField = this.props.fields.find(x => x.id == event.target.id)

    let passThroughData = !event
      ? data
      : {
          id: event.target.id,
          changed: this.props.target != event.target.value,
          initial: targetField.target,
          target: event.target.value
        }

    this.props.onChange(null, {
      ...passThroughData,
      parentField: this.props.id
    })
  }

  // the field menu every text row has (TranslationField.renderFieldMenu), for the SEO rows this
  // component draws itself: import / machine translation, clear translation, the status
  openFieldMenu = (event, fieldId) => {
    event.stopPropagation()
    this.setState({ menuAnchor: event.currentTarget, menuFieldId: fieldId })
  }

  // the field id stays: SourceToTargetMenu closes the menu before it opens its import dialog, and
  // dropping the id here unmounted it together with the dialog and the pending import
  closeFieldMenu = () => {
    this.setState({ menuAnchor: null })
  }

  clearSeoTranslation = (field) => {
    this.closeFieldMenu()
    this.props.onChange(null, {
      id: field.id,
      changed: field.target !== '',
      initial: field.target,
      target: '',
      parentField: this.props.id
    })
    if (this.props.onTriggerForceUpdate) this.props.onTriggerForceUpdate()
  }

  // like TranslationField: the row keeps 28px on the right for the kebab, which sits in that room
  // next to the target, not over it
  renderFieldMenuButton = (field) => (
    <div style={{ position: 'absolute', top: 6, right: 16 }}>
      <Tooltip title={this.props.t('itemsList.fieldMenu')} arrow>
        <IconButton aria-label={this.props.t('itemsList.fieldMenu')} onClick={e => this.openFieldMenu(e, field.id)} size="small">
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
    </div>
  )

  keepSeoTranslation = (field) => {
    this.closeFieldMenu()
    this.props.onKeepTranslation(field.id, this.props.id)
  }

  renderFieldMenu = () => {
    const { t } = this.props
    const field = this.props.fields.find(x => x.id === this.state.menuFieldId)
    if (!field) return null
    const hasTarget = field.target !== '' && field.target !== null && field.target !== undefined
    // same rule as TranslationField: only a section that flags outdated translations shows the
    // state and the "keep translation" entry; none flags SEO fields yet, the rows are ready for it
    const outdated = hasTarget && this.props.flagsOutdated === true && field.outdated === true
    const StatusIcon = !hasTarget ? RadioButtonUncheckedIcon : (outdated ? ErrorOutlineIcon : CheckCircleOutlineIcon)
    return (
      <SourceToTargetMenu
        variant="menu"
        anchorEl={this.state.menuAnchor}
        onClose={this.closeFieldMenu}
        data={field}
        from={this.props.from}
        to={this.props.to}
        onChange={this.props.onChange}
        onTriggerForceUpdate={this.props.onTriggerForceUpdate}
        parentField={this.props.parentField}
      >
        {outdated && this.props.onKeepTranslation && (
          <MenuItem key="keep" dense onClick={() => this.keepSeoTranslation(field)}>
            <ListItemIcon><CheckCircleOutlineIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary={t('itemsList.fieldKeepTranslationBtn')} secondary={t('itemsList.fieldKeepTranslationHint')} />
          </MenuItem>
        )}
        {hasTarget && (
          <MenuItem key="clear" dense onClick={() => this.clearSeoTranslation(field)}>
            <ListItemIcon><BackspaceOutlinedIcon fontSize="small" /></ListItemIcon>
            <ListItemText>{t('imageField.clearTranslationBtn')}</ListItemText>
          </MenuItem>
        )}
        <ListSubheader key="status" disableSticky sx={{ lineHeight: '28px' }}>{t('itemsList.fieldStatus')}</ListSubheader>
        <Typography key="status-value" component="div" variant="body2" sx={{ px: 2, pb: 1, display: 'flex', alignItems: 'center', gap: 1, maxWidth: 320, color: outdated ? 'warning.main' : 'text.secondary' }}>
          <StatusIcon fontSize="small" sx={{ color: !hasTarget ? 'text.disabled' : (outdated ? 'warning.main' : 'success.main'), flexShrink: 0 }} />
          <span>{t(!hasTarget ? 'itemsList.fieldStatusEmpty' : (outdated ? 'itemsList.fieldStatusOutdated' : 'itemsList.fieldStatusTranslated'))}</span>
        </Typography>
      </SourceToTargetMenu>
    )
  }

  /**
   * Returns the value of a given SEO field depending on state.inheritSeoFields
   * and if the original fields target has a value or not. If the target has no value it would
   * return field.source instead of field.target
   *
   * @param {*} fieldId
   */
  getSeoFieldValue = (fieldId, customized) => {
    let field = null
    let val = null
    let maxLength = fieldId === 'page_title' ? 255 : 500

    if (!customized) {
      let _fieldId = fieldId
        .replace('page_', '')
        .replace('description', 'body_html')
      field = this.props.rawData.find(x => x.id === _fieldId)

      if (field && field.target == '' && this.props.fields.length) {
        if (
          field.source !== this.props.fields.find(x => x.id === fieldId).source
        ) {
          field = this.props.fields.find(x => x.id === fieldId)
        }
      } else if (
        field &&
        this.props.fields.length &&
        this.props.fields.find(x => x.id === fieldId).target !== ''
      ) {
        field = this.props.fields.find(x => x.id === fieldId)
      }
    } else {
      field = this.props.fields.find(x => x.id === fieldId)
    }

    if (field) {
      let val =
        field.target !== '' || customized
          ? this.convertHtmltoText(field.target)
          : this.convertHtmltoText(field.source)
      return this.trimSeoField(val, maxLength)
    }
    return ''
  }

  convertHtmltoText(html) {
    if (!html) return false
    var res = html.replace(/<[^>]*>/g, '') // Remove HTML tags
    res = res.replace(/\{\{[^}]*\}\}/g, '') // Remove liquid output tags {{ }}
    res = res.replace(/\{%[^%]*%\}/g, '') // Remove liquid logic tags {% %}
    res = res.replace(/&nbsp;/g, ' ') // Replace non-breaking spaces with regular spaces
    res = res.replace(/\u00A0/g, ' ') // Replace Unicode non-breaking spaces
    res = res.replace(/[\u201C\u201D]/g, '"') // Replace smart quotes with straight quotes
    res = res.replace(/[\u2018\u2019]/g, "'") // Replace smart apostrophes with straight apostrophes
    res = res.replace(/[\u2013\u2014]/g, '-') // Replace em/en dashes with hyphens
    res = res.replace(/[\u200B\u200C\u200D\uFEFF]/g, '') // Remove zero-width characters
    res = res.replace(/\s+/g, ' ') // Collapse multiple whitespaces to single space
    //res = res.trim() // Remove leading/trailing whitespace
    return res
  }

  trimSeoField(string, maxLength = 70) {
    if (!string) return null
    var trimmedString =
      string.length > maxLength
        ? string.substring(0, maxLength - 3) + '...'
        : string
    return trimmedString
  }

  getProps(field) {
    const toLanguage = this.props.languages.languages.find(
      x => x.id == this.props.shop.shop.edit_language
    )

    let myInputProps = {
      //maxLength: field.maxLength ? field.maxLength : null,
      dir: toLanguage && toLanguage.rtl ? 'rtl' : 'ltr'
    }

    if (field.customized === false) {
      myInputProps['disabled'] = 'disabled'
    }

    return myInputProps
  }

  renderTranslationField(field) {
    const { t, fields, isFirst } = this.props
    // The value must never be null/false: that flips the input to uncontrolled and freezes the displayed text
    return (
      <TextField
        id={field.id}
        data={field}
        multiline={field.multiline}
        minRows={field.rows}
        maxRows={field.rows ? field.rows : 1}
        fullWidth
        value={this.getSeoFieldValue(field.id, field.customized) || ''}
        onChange={this.handleChange}
        margin="none"
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        InputProps={{
          sx: {
            ...styles.textField,
            '& .MuiInputBase-input': styles.inputField,
            '& .MuiInputBase-inputMultiline': styles.inputField,
          }
        }}
        inputProps={this.getProps(field)}
        sx={styles.textField}
        focused={
          field.customized ? field.id == this.props.getFieldIdByHash() : false
        }
      />
    )
  }

  renderTranslationFieldWithTooltip(field) {
    const { t, fields, isFirst } = this.props

    return (
      <HtmlTooltip
        arrow
        title={
          field.customized ? (
            ''
          ) : (
            <React.Fragment>
              <InfoIcon
                style={{
                  float: 'right',
                  position: 'relative',
                  left: 8,
                  bottom: 6
                }}
              />
              <div>
                <Typography style={{ paddingBottom: 8 }}>
                  <span color="inherit">{t('itemsList.seoTooltipTitle')}</span>
                </Typography>
                <span style={{ fontSize: 12 }}>
                  {t('itemsList.seoTooltipDescription')}
                </span>
              </div>
            </React.Fragment>
          )
        }>
        {this.renderTranslationField(field)}
      </HtmlTooltip>
    )
  }

  render() {
    const { t, fields, isFirst } = this.props
    const {} = this.state

    const truncate = (input, len) =>
      input.length > len ? `${input.substring(0, len)}...` : input
    const fromLanguage = this.props.languages.languages.find(
      x => x.base == true
    )

    return (
      <Box
        className={classNames(
          'collapsable-fields',
          isFirst && 'first',
          this.props.type,
          this.props.id,
        )}
        sx={styles.root}>
        <Typography
          variant="subtitle1"
          sx={styles.headline}>
          {this.state.inheritSeoFields
            ? t('itemsList.seoPreview')
            : t('itemsList.seoFields')}
        </Typography>

        <Collapse in={this.state.inheritSeoFields}>
          <HtmlTooltip
            arrow
            title={
              <React.Fragment>
                <InfoIcon
                  style={{
                    float: 'right',
                    position: 'relative',
                    left: 8,
                    bottom: 6
                  }}
                />
                <div>
                  <Typography style={{ paddingBottom: 8 }}>
                    <span color="inherit">
                      {t('itemsList.seoTooltipTitle')}
                    </span>
                  </Typography>
                  <span style={{ fontSize: 12 }}>
                    {t('itemsList.seoTooltipDescription')}
                  </span>
                </div>
              </React.Fragment>
            }>
            <Paper sx={styles.paper} elevation={1}>
              <Typography variant="h4" style={{ marginBottom: 4 }}>
                {this.getSeoFieldValue('page_title', false)}
              </Typography>
              <Typography variant="caption" component="p">
                {this.getSeoFieldValue('page_description', false)}
              </Typography>
            </Paper>
          </HtmlTooltip>
        </Collapse>
        <Collapse in={!this.state.inheritSeoFields}>
          <div style={{ paddingTop: 8, paddingBottom: 12 }}>
            {fields.map(field => (
              <React.Fragment key={`seofields-${field.id}`}>
                <Grid
                  container
                  spacing={3}
                  style={{ paddingRight: 24 + 28, paddingLeft: 24 }}
                  className={classNames(
                    'field-row',
                    field.id
                  )}
                  sx={{
                    ...styles.gridRoot,
                    marginBottom: '8px !important',
                  }}>
                  {/* only a customized field is editable, the inherited one has nothing to act on */}
                  {field.customized && this.renderFieldMenuButton(field)}
                  {/* the arrow with the hover menu, same shared actions as the kebab; shifted like styles.arrow */}
                  {field.customized &&
                    <SourceToTargetMenu
                      centered
                      data={field}
                      from={this.props.from}
                      to={this.props.to}
                      onChange={this.props.onChange}
                      onTriggerForceUpdate={this.props.onTriggerForceUpdate}
                      parentField={this.props.parentField}
                      arrowStyle={{ left: 'calc(50% - 12px - 14px)' }}
                    />
                  }
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{'&.MuiGrid-item': styles.gridOdd}}
                    onClick={() =>
                      this.props.selectField(
                        this.props.itemId,
                        field.id,
                        'seofields'
                      )
                    }>
                    <TextField
                      label={
                        field.label && field.label.length >= 50 ? (
                          <Tooltip
                            slotProps={{
                              tooltip: { sx: styles.noMaxWidth },
                            }}
                            placement="bottom"
                            arrow>
                            <span>{truncate(field.label, 50)}</span>
                          </Tooltip>
                        ) : (
                          field.label
                        )
                      }
                      disabled
                      multiline={field.multiline}
                      minRows={field.rows}
                      maxRows={field.rows ? field.rows : 1}
                      fullWidth
                      value={field.source ? field.source : ''}
                      margin="none"
                      variant="outlined"
                      InputLabelProps={{
                        style: { pointerEvents: 'auto' },
                        shrink: true,
                        sx: styles.label
                      }}
                      InputProps={{
                        sx: {
                          ...styles.textField,
                          ...styles.disabledField,
                          '& .MuiInputBase-input': styles.inputField,
                          '& .MuiInputBase-inputMultiline': styles.inputField,
                        }
                      }}
                      inputProps={{
                        dir: fromLanguage && fromLanguage.rtl ? 'rtl' : 'ltr'
                      }}
                      sx={[styles.textField, styles.targetField]}
                    />
                  </Grid>
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{'&.MuiGrid-item': styles.gridEven}}
                    onClick={() =>
                      this.props.selectField(
                        this.props.itemId,
                        field.id,
                        'seofields'
                      )
                    }>
                    {field.customized
                      ? this.renderTranslationField(field)
                      : this.renderTranslationFieldWithTooltip(field)}
                  </Grid>
                </Grid>
                {field.maxLength && field.target && (
                  <div style={{ textAlign: 'right', paddingRight: 24 + 28, marginTop: -4 }}>
                    <Typography
                      variant="caption"
                      color="text.secondary">{`${
                      field.target.length
                    } of ${field.maxLength} characters used`}</Typography>
                  </div>
                )}
              </React.Fragment>
            ))}
            {this.renderFieldMenu()}
          </div>
        </Collapse>
      </Box>
    )
  }
}

const styles = {
  // the old centered arrow, shifted half the 28px the kebab takes on the right so it stays
  // between the two columns; hidden where they stack
  arrow: (theme) => ({
    position: 'absolute',
    left: 'calc(50% - 12px - 14px)',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    zIndex: 1,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }),
  root: {
    marginLeft: '-24px',
    marginRight: '-24px',
    backgroundColor: 'surfaceRecessed'
  },
  gridRoot: {
    position: 'relative !important',
    margin: '0 !important',
    '&.image': {
      display: 'inline-block',
      width: 'auto',
      margin: '0 !important',
      paddingRight: '24px'
    }
  },
  gridOdd: (theme) => ({
    [theme.breakpoints.down('md')]: {
      paddingBottom: '0 !important',
      '&>div': {
        marginBottom: 0,
        '& fieldset': {
          borderBottom: 'none',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      },
      '& .ly-editor>div': {
        marginBottom: '0 !important',
        '& .redactor-box': {
          borderBottom: 'none',
          borderBottomLeftRadius: '0 !important',
          borderBottomRightRadius: '0 !important'
        }
      }
    }
  }),
  gridEven: {},
  textField: {
    margin: 0,
    padding: 0,
    backgroundColor: 'background.paper',
    '&& [disabled]': {
      backgroundColor: 'surfaceRecessed',
      color: 'text.disabled'
    }
  },
  inputField: {
    padding: '12px 14px !important',
    fontSize: '14px !important',
    height: 'auto !important'
  },
  targetField: {
    borderStyle: 'dashed !important'
  },
  disabledField: {
    backgroundColor: 'surfaceRecessed'
  },
  headline: {
    padding: '8px 24px 8px 24px',
    position: 'relative'
  },
  label: {
    color: 'text.secondary',
    cursor: 'pointer',
    padding: '12px 24px',
    fontSize: '1rem',
    transform: 'translate(-4px, -14px) scale(0.75) !important'
  },
  paper: {
    margin: '6px 24px 24px 24px !important',
    padding: '12px',
    '& h4': {
      fontSize: '1.2rem'
    },
    '& p': {
      color: 'text.secondary'
    }
  },
  maxCharCount: {
    position: 'absolute',
    right: '12px',
    bottom: '-20px',
    color: 'text.secondary',
  },
  noMaxWidth: {
    maxWidth: 'none',
    marginLeft: '50px',
  },
}

const mapStateToProps = ({ shop, languages }) => ({
  shop: shop,
  languages: languages
})
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateAutoTranslations
    },
    dispatch
  )

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(SeoFields))
)
